import { Link as RouterLink } from '@tanstack/react-router';
import { endpoints } from '_/lib/frontend-utils';
import { Typography } from 'antd';
import React, { ReactElement, ReactNode } from 'react';

import { isWorkBench } from '../../utils/environmentUtils';

interface WorkbenchLinkProps {
  href: string;
  children: ReactNode;
  supported?: boolean;
}

function WorkbenchLink({ href, children, supported }: WorkbenchLinkProps): ReactElement {
  return isWorkBench() && !supported ? (
    <Typography.Link href={`https://workbench-old.${endpoints.rootDomain}${href}`} underline>
      {children}
    </Typography.Link>
  ) : (
    <RouterLink to={href} style={{ textDecoration: 'underline' }}>
      {children}
    </RouterLink>
  );
}

export default WorkbenchLink;
